export const filterString = (str1, str2) => {
  str1 = str1.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  str2 = str2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  return str1.toLowerCase().indexOf(str2.toLowerCase()) >= 0;
}

export const filterSelectOptions = (inputValue, option) => {
  return filterString(
    typeof option.children === 'string' ? option.children :
      (typeof option.label === 'string' ? option.label : '')
    , inputValue
  );
}
